/** Shown on marketing pages and merged into subscription plan feature lists. */
export const WHATSAPP_PLAN_FEATURE =
  'WhatsApp Integration & Prescription PDF Share';

const WHATSAPP_FEATURE_PATTERN = /whatsapp/i;

/** Ensures WhatsApp appears in plan feature bullets (homepage, signup, settings). */
export function displayPlanFeatures(
  dbFeatures: string[],
  limit = 4
): string[] {
  const hasWhatsApp = dbFeatures.some((f) => WHATSAPP_FEATURE_PATTERN.test(f));
  const list = hasWhatsApp
    ? dbFeatures
    : [WHATSAPP_PLAN_FEATURE, ...dbFeatures];
  return list.slice(0, limit);
}

export const DEFAULT_PLAN_FALLBACK_FEATURES = [
  WHATSAPP_PLAN_FEATURE,
  'Unlimited Patients',
  'All Features Included',
  'Email Support',
] as const;
